module.exports = __webpack_public_path__ + "img/vesper2.f53937ef.jpg";